import { SpinResultData } from "@lib/titan2-slingo/dist/api/model/data/SpinResultData";
import { ApiConstants } from "../enum/ApiConstants";
import { ChanceGameData } from "./ChanceGameData";
import { CollectWinResultData } from "./CollectWinResultData";
import { WinLineData } from "./WinLineData";
/**
 * ExtendedSpinResultData.ts
 */
export class ExtendedSpinResultData extends SpinResultData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifySymbolHint();
            this.solidifyChanceGame();
            // It isn't possible to get both a chance game and a win line together.
            if (!this.chanceGame) {
                this.solidifyWinLine();
            }
        }
    }
    solidifySymbolHint() {
        const feature = this.data.getDataObject(ApiConstants.PROPERTY_FEATURE);
        if (this.dataExists(feature)) {
            const symbolHint = feature.getNumber(ApiConstants.PROPERTY_SYMBOL_HINT);
            if (this.dataExists(symbolHint)) {
                this.symbolHint = symbolHint;
            }
            const winnings = feature.getDataObject(ApiConstants.PROPERTY_WINNINGS);
            this.winnings = new CollectWinResultData(winnings);
        }
    }
    getCollectWinnings() {
        return this.winnings;
    }
    /** To only be used by the game test */
    debug_setCollectWinnings(winnings) {
        this.winnings = winnings;
    }
    getSymbolHint() {
        return this.symbolHint;
    }
    solidifyChanceGame() {
        const feature = this.data.getDataObject(ApiConstants.PROPERTY_FEATURE);
        if (this.dataExists(feature)) {
            const chanceGame = feature.getDataObject(ApiConstants.PROPERTY_CHANCE_GAME);
            if (this.dataExists(chanceGame)) {
                this.chanceGame = new ChanceGameData(chanceGame);
                return;
            }
        }
        this.chanceGame = null;
    }
    getChanceGame() {
        return this.chanceGame;
    }
    solidifyWinLine() {
        const symbolWins = this.data.getDataArray(ApiConstants.PROPERTY_SYMBOL_WINS);
        if (this.dataExists(symbolWins)) {
            const symbolWinWithSymbols = symbolWins.find(symbolWin => symbolWin.containsKey(ApiConstants.PROPERTY_SYMBOLS));
            if (this.dataExists(symbolWinWithSymbols)) {
                this.winLine = new WinLineData(symbolWinWithSymbols);
                return;
            }
        }
        this.winLine = null;
    }
    getWinLine() {
        return this.winLine;
    }
}
//# sourceMappingURL=ExtendedSpinResultData.js.map